import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type srcAsyncCreateIssueTypeQuery$variables,
} from './src/__generated__/srcAsyncCreateIssueTypeQuery.graphql';

export const asyncCreateIssueTypeModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-create-issue-type-modal-entrypoint" */ './src'),
	),
	getPreloadProps: ({
		projectKey,
		cloudId,
		shouldFetchProjectData,
	}: srcAsyncCreateIssueTypeQuery$variables) => ({
		queries: {
			createIssueTypeModal: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters,
				variables: { projectKey, cloudId, shouldFetchProjectData },
			},
		},
	}),
});
